module.exports = __webpack_public_path__ + "img/分组 26-1.9a4c47d2.png";